<template>
  <div class="what-is-gender">
    <div class="wig-body">
      <div class="wigb-answer">
        <div
          class="wigba-wrapper answer1 mobile"
          @click.once="pushPath1(answer1.value)"
          :class="{
            active: value === answer1.value,
            answer: value,
            tutorials: tutorials,
          }"
        >
          <div class="wigba-detail-ab">
            <div class="lable">{{ answer1.label }}</div>
            <div class="sub-title" v-if="answer1Description">
              {{ answer1Description }}
            </div>
          </div>
          <div class="wigbaw-pic">
            <img class="wigbaw-img" :src="answer1.image" :alt="answer1.label" />
          </div>
        </div>

        <div class="wigba-question">
          <div class="wrap-question">
            <h4 class="wigbaq-title">{{ title }}</h4>
            <h3 class="wigbaq-sub-title" v-if="description">
              {{ description }}
            </h3>
            <div
              class="rvybaq-diff"
              v-if="info"
              @click.once="$router.push({ path: info.path })"
            >
              {{ info.title }}
              <img
                class="rvybaqd-img"
                src="@/assets/icons/caret-white-link-info.svg"
                alt="chevron-right"
              />
            </div>
          </div>
        </div>

        <div
          class="wigba-wrapper answer2 mobile"
          @click.once="pushPath2(answer2.value)"
          :class="{
            active: value === answer2.value,
            answer: value,
            tutorials: tutorials,
          }"
        >
          <div class="wigba-detail-ab ab-detail-footer">
            <div class="lable">{{ answer2.label }}</div>
            <div class="sub-title" v-if="answer2Description">
              {{ answer2Description }}
            </div>
          </div>
          <div class="wigbaw-pic">
            <img class="wigbaw-img" :src="answer2.image" :alt="answer2.label" />
          </div>
        </div>
      </div>
    </div>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer, { QUESTION_INFO } from "@/components/StateAnswer.vue";

export default {
  name: "Character",
  props: [
    "name",
    "description",
    "info",
    "answer1Description",
    "answer2Description",
    "answer1NextPath",
    "answer2NextPath",
    "showTutorials",
  ],
  components: {
    StateAnswer,
  },
  data() {
    const questionInfo = QUESTION_INFO.find((info) => info.name === this.name);
    return {
      title: questionInfo.label,
      answer1: questionInfo.options[0],
      answer2: questionInfo.options[1],
      value: this.$store.state.questions.answers[this.name],
    };
  },
  computed: {
    tutorials() {
      return this.showTutorials;
    },
  },
  methods: {
    changeAnswer(value) {
      this.$store.dispatch("questions/changeAnswer", {
        name: this.name,
        value: value,
      });
    },
    pushPath1(value) {
      this.changeAnswer(value);
      if (this.answer1NextPath) {
        this.$router.push({ path: this.answer1NextPath });
      } else {
        this.$router.push({ path: this.answer1.nextPath });
      }
    },
    pushPath2(value) {
      this.changeAnswer(value);
      if (this.answer2NextPath) {
        this.$router.push({ path: this.answer2NextPath });
      } else {
        this.$router.push({ path: this.answer2.nextPath });
      }
    },
  },
};
</script>

<style scoped>
.what-is-gender {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.wig-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  position: relative;
}
.wigb-answer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 414px;
  position: relative;
}
.wigba-background-ab {
  position: absolute;
  width: 100%;
  height: 65px;
  background: #acb1bf;
  mix-blend-mode: multiply;
  z-index: -1;
}
.wigba-detail-ab {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  z-index: 1;
  color: #ffffff;
  width: 100%;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.ab-background-footer {
  bottom: 0;
}
.ab-detail-footer {
  bottom: 0;
}

.wigba-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 414px;
  height: 343px;
  cursor: pointer;
}
.wigbaw-detail {
  position: absolute;
  top: 0;
  left: 0px;
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.wigbaw-detail-footer {
  bottom: 0px;
  top: unset;
}
.wigbawd-background {
  position: absolute;
  width: 100%;
  height: 65px;
  background: #acb1bf;
  mix-blend-mode: multiply;
  z-index: -1;
}

.wigbaw-img {
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.wigba-wrap-question {
  margin: 40px;
}
.wigba-question {
  position: absolute;
  width: 323px;
  height: 150px;
  top: 50%;
  left: 50%;
  background: rgba(0, 0, 0, 0.6);
  transform: translate(-50%, -50%);
  bottom: -52px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  flex-direction: column;
  color: #ffffff;
}
.wrap-question {
  margin: 20px;
}
.wigbaq-title {
  white-space: break-spaces;
}
.wigbaq-sub-title {
  font-size: 12px;
  font-weight: normal;
}
.sub-title {
  font-weight: bold;
}
.rvybaq-diff {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
  text-decoration: underline;
}
.rvybaqd-img {
  margin-left: 10px;
}
.lable {
  white-space: break-spaces;
}
.mobile .wigbaw-pic {
  width: 100%;
  height: 100%;
  position: relative;
}
.mobile.answer .wigbaw-pic {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6));
}
.mobile.answer.active .wigbaw-pic {
  background: unset;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .wigb-answer {
    flex-direction: row;
    max-width: unset;
  }
  .wigba-wrapper {
    width: 100%;
    max-width: unset;
    height: 684px;
    min-height: calc(100vh - 250px);
  }
  .ab-detail-footer {
    top: 0;
  }
  .wrap-question {
    margin: 31px 53px;
  }
  .wigba-question {
    width: 480px;
  }
  .wigbaw-pic {
    width: 100%;
    height: 100%;
    position: relative;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6));
  }
  .tutorials .wigbaw-pic {
    background: unset;
  }
  .wigba-wrapper:hover .wigbaw-pic,
  .wigba-wrapper.active .wigbaw-pic {
    background: unset;
  }
  .what-is-gender {
    max-width: 1440px;
    margin: auto;
  }
}
</style>
